import { normalizeRoleSlug } from "../../../public/utils/roleAccess";
import {
  PHONE_CALL_LOGS_CONTROL_SUBMODULE_SLUG,
  PHONE_CALL_LOGS_SUBMODULE_SLUG,
} from "./callLogPermissionSlugs";

function permRow(permMap, slug) {
  const row = permMap?.[slug];
  return row && typeof row === "object" ? row : {};
}

function submodulePerm(permMap, slug, type) {
  if (!permMap || !slug) return false;
  const row = permMap[slug];
  if (!row || typeof row !== "object") return false;
  return Boolean(row[type]);
}

/** Office call logs register — User builder `phone-call-logs` row. */
function callLogsRegisterStylePerms(row) {
  const canView = Boolean(row.view);
  const canCreate = Boolean(row.create);
  const canEdit = Boolean(row.edit);
  const canDelete = Boolean(row.delete);
  return {
    canView: canView || canCreate,
    canCreate,
    canEdit,
    canDelete,
    canManageMasters: false,
    canDeleteMasters: false,
    canExport: canView || canCreate,
    isAdmin: false,
  };
}

/** Admin call logs control — User builder `phone-call-logs-control` row. */
function callLogsControlStylePerms(permMap) {
  const row = permRow(permMap, PHONE_CALL_LOGS_CONTROL_SUBMODULE_SLUG);
  const registerRow = permRow(permMap, PHONE_CALL_LOGS_SUBMODULE_SLUG);
  const canView = Boolean(row.view);
  const canEdit = Boolean(row.edit);
  const canDelete = Boolean(row.delete);
  const canCreate = Boolean(row.create) || Boolean(registerRow.create);
  return {
    canView,
    canCreate,
    canEdit,
    canDelete,
    canManageMasters: canView && canEdit,
    canDeleteMasters: canDelete,
    canExport: canView,
    isAdmin: canView,
  };
}

/**
 * Permissions for one call-logs screen (User builder submodule row).
 * All roles — including admin — follow User builder only.
 */
export function buildCallLogPermissionsForScreen(
  permMap = {},
  _roleSlug = "",
  screenSlug = "",
) {
  const slug = normalizeRoleSlug(screenSlug);

  if (slug === PHONE_CALL_LOGS_SUBMODULE_SLUG) {
    return callLogsRegisterStylePerms(permRow(permMap, slug));
  }

  if (slug === PHONE_CALL_LOGS_CONTROL_SUBMODULE_SLUG) {
    return callLogsControlStylePerms(permMap);
  }

  return buildCallLogPermissions(permMap);
}

export function buildCallLogPermissions(permMap = {}) {
  const canControl = submodulePerm(permMap, PHONE_CALL_LOGS_CONTROL_SUBMODULE_SLUG, "view");
  const registerRow = permRow(permMap, PHONE_CALL_LOGS_SUBMODULE_SLUG);
  const controlRow = permRow(permMap, PHONE_CALL_LOGS_CONTROL_SUBMODULE_SLUG);
  const canView =
    Boolean(registerRow.view) ||
    Boolean(registerRow.create) ||
    canControl;
  const canCreate = Boolean(registerRow.create) || Boolean(controlRow.create);
  const canEdit = Boolean(registerRow.edit) || Boolean(controlRow.edit);
  const canDelete = Boolean(controlRow.delete);

  return {
    canView,
    canCreate,
    canEdit,
    canDelete,
    canManageMasters: canControl && Boolean(controlRow.edit),
    canDeleteMasters: canControl && Boolean(controlRow.delete),
    canExport: canView,
    isAdmin: canControl,
  };
}
